export default __webpack_public_path__ + "Cta2hK2-report.svg";